import * as EnvironmentUtils from "./EnvironmentUtils";

export const isFiveKeysTheme = () => {
	if (EnvironmentUtils.isProductionBuild()) {
		return /(.*\.)?\.5keysengage\.com$/.test(window.location.hostname);
	}

	return (
		/(.*\.)?\.5keysengage\.com$/.test(window.location.hostname) ||
		process.env.REACT_APP_VARIANT === "5keys"
	);
};
